<template>
  <div>
    <div>
      <b-modal ref="alertModal" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <p>{{this.alertMessage}}</p>
      </b-modal>
      <b-modal ref="erroPush" @ok="confirmaErroPush" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <p>{{this.erroPushMsg}}</p>
      </b-modal>
    </div>
    <Header :home="false" :logged="logged" :loading="loggedLoading" :arealogada="true"/>
    <div id="painel" class="container-fluid">
      <b-row>
        <b-col cols="12" md="4" lg="3" v-if="show" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex" style="padding: 0;">
          <b-container fluid id="painelcontainerfluid">
            <b-row class="breadcrumb-row">
              <b-col cols="10" style="padding: 0;">
                <b-breadcrumb :items="breadCrumb"></b-breadcrumb>
              </b-col>
              <b-col cols="2" style="padding: 0.75rem 1rem;" >
                <b-link class="btn-voltar" href="/painel" style="text-decoration:none;font: normal normal bold 16px/24px 'Kanit', sans-serif;color:#597EB5;">
                  Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                </b-link>
              </b-col>
            </b-row>
            <b-alert  show variant="danger"><a href="https://www.protestosp.com.br/Certidoes/Index" target="_blank" style="color: inherit; text-decoration: none; cursor: pointer;">
              <figure class="flag float-left flag-notificacao"><img :src="require('@/assets/imgs/bandeiras/flag-sp.png')"></figure>
              Para pedidos de certidão do estado de SP. Clique aqui
            </a></b-alert>
                <b-form name="frmProcuracao" id="frmProcuracao">
                  <div class="text-center" v-if="loading" style="background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;width: 100%;height: 100%;position: absolute;display: block;z-index: 10002;margin: 0;top: 0;padding-top: 20%;">
                    <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Text Centered"></b-spinner> <br><span style="color:#004E86">Processando Aguarde...</span>
                  </div>
                  <!-- <div class="d-lg-none">
                    <button class="mt-4" v-on:click="show = !show">
                        <font-awesome-icon size="1x" icon="bars" />
                    </button>
                  </div> -->
                  <h4 class="text-primary mt-5 text-center"><b>Solicitar certidão de protesto</b></h4>
                  <b-tabs v-model="tabIndex" content-class="mt-3" align="center" class="ul-ieptb">
                    <b-tab title="01" active>
                      <b-row>
                        <b-col cols="12" md="4">
                          <h4 class="text-primary mb-3">Informações da Solicitação</h4>
                        </b-col>
                        <b-col cols="6" >
                          
                        </b-col>
                        <b-col cols="6" md="2" class="mb-3">
                          <b-button block variant="danger" type="button" @click="limparDados" >Limpar Dados</b-button>
                        </b-col> 
                      </b-row>
                      <div class="mb-4">
                        <div>
                      <b-card border-variant="primary-ieptb" header-text-variant="primary-ieptb" class="card-ieptb"  header="">
                      <b-card-text>
                        <b-row>
                            <b-col cols="12" md="9" lg="9" >
                                <label for="nome_solicitante">Nome completo do pesquisado <small>(Nome que será emitido na Certidao)</small></label>
                                <b-input v-model="form.nome_solicitante" maxlength="100" placeholder="Nome completo" :state="validation_nome_solicitante" id="outorgante_nome" required></b-input>
                                <b-form-invalid-feedback :state="validation_nome_solicitante">
                                    Infome o nome completo.
                                </b-form-invalid-feedback>
                            </b-col>
                            
                            <b-col cols="12" md="3" lg="3">
                              <label for="documento_solicitante">Documento do pesquisado</label>
                              <b-input
                                v-model="documento_solicitante"
                                placeholder="Documento"
                                maxlength="18"
                                :state="validation_documento_solicitante"
                                id="outorgado_documento"
                                :formatter="documento"
                                required>
                              </b-input>
                              <b-form-invalid-feedback :state="validation_documento_solicitante">
                                  Infome um documento válido.
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                          <b-row class="mt-3">
                            <b-col cols="12" md="3" lg="3">
                              <label>RG pesquisado:</label>
                              <b-form-input
                                ref="sg_rg"
                                v-model="form.rg_solicitante"
                                maxlength="18"
                                required
                                :state="validation_rg_solicitante"
                                :formatter="documento"
                                >
                              </b-form-input>
                              <b-form-invalid-feedback :state="validation_rg_solicitante">
                                  Infome um RG válido.
                              </b-form-invalid-feedback>
                            </b-col>
                            <b-col cols="12" md="9" lg="9" >
                                <label for="email_pesquisado">E-mail:</label>
                                <b-form-input id="email_pesquisado" ref="email_pesquisado" v-model="form.dadosPesquisado.email"></b-form-input>
                                </b-col>
                          </b-row>
                            <b-row>
                              <b-col cols="12" md="12" lg="12">
                                <br>
                                <hr />
                                <h4 class="text-primary mt-4">Endereço</h4>
                                
                              </b-col>
                            </b-row>
                          <b-row>
                            <b-col cols="12" md="4" lg="3" >
                              <label>CEP:</label>
                              <b-form-input
                                v-model="pesquisado_cep"
                                maxlength="18"
                                :state="validations.pesquisado_cep"
                                :formatter="cep"
                                required>
                              </b-form-input>
                              <b-form-invalid-feedback :state="validations.pesquisado_cep">
                                  Infome um cep válido.
                              </b-form-invalid-feedback>
                            </b-col>
                              <b-col cols="12" md="4" lg="7" >
                                <label for="inputEmail4">Endereço:</label>
                                <b-form-input id="endereco_pesquisado" ref="endereco_pesquisado" v-model="form.dadosPesquisado.endereco" :state="validations.pesquisado_endereco"></b-form-input>
                              </b-col>
                              <b-col cols="12" md="4" lg="2" >
                                <label>UF:</label>
                                <b-form-input v-model="sg_uf" :state="validations.pesquisado_uf"></b-form-input>
                              </b-col>
                            </b-row>
                          <b-row class="mt-3">
                            <b-col cols="12" md="8" lg="8" >
                                <label for="cidade_pesquisado">Cidade:</label>
                                <b-form-input id="cidade_pesquisado" ref="cidade_pesquisado" v-model="form.dadosPesquisado.cidade" :state="validations.pesquisado_cidade"></b-form-input>
                              </b-col>
                              <b-col cols="12" md="4" lg="4" >
                                <label for="bairro_pesquisado">Bairro:</label>
                                <b-form-input id="bairro_pesquisado" ref="bairro_pesquisado" v-model="form.dadosPesquisado.bairro" :state="validations.pesquisado_bairro"></b-form-input>
                                </b-col>                                  
                          </b-row>
                          <b-row>
                              <b-col cols="12" md="12" lg="12">
                                <br>
                                <hr />
                                <h4 class="text-primary mt-4">Dados do cartório</h4>
                                
                              </b-col>
                            </b-row>
                            <b-row>
                          <b-col cols="12" md="4" lg="4">
                                  <label for="outorgante_nome">Selecione um estado</label>
                                  <b-form-select @change="selecionaUf($event)" v-model="form.ufselecionada" :options="estados" :state="validation_uf_selecionada"></b-form-select>
                                  <b-form-invalid-feedback :state="validation_uf_selecionada">
                                  Selecione um estado.
                              </b-form-invalid-feedback>
                            </b-col>
                                <b-col cols="12" md="8" lg="8">
                                  <b-form-group
                                    id="estado"
                                    label="Selecione um município"
                                    label-for="estado"
                                  >
                                    <b-form-select @change="buscarCartorios($event)" v-model="form.comarca_selecionada" :options="municipios" :state="validation_comarca_selecionada"></b-form-select>
                                      </b-form-group> 
                                      <b-form-invalid-feedback :state="validation_comarca_selecionada">
                                        Infome um município.
                                      </b-form-invalid-feedback>
                                </b-col>
                              </b-row>
                            <b-row>
                              <b-col cols="12" md="4" lg="12">
                                  <b-form-group
                                    id="cartorio"
                                    label="Selecione um cartório"
                                    label-for="cartorio"
                                    description=' Ao clicar no campo "Cartório", 
                                    você pode utilizar as teclas de atalho para selecionar determinados cartórios, 
                                    pressionando simultaneamente "CTRL + CLICK" OU "CTRL + SHIFT + CLICK" OU "CTRL + A"
                                    '
                                  >
                                    <b-form-select v-model="form.cartorios_selecionados" multiple @change="selecionaCartorio($event)" :options="cartorios" :state="validation_cartorios_selecionados" ></b-form-select>
                                  </b-form-group>
                                    <b-form-invalid-feedback :state="validation_cartorios_selecionados">
                                        Informe ao menos um cartório.
                                    </b-form-invalid-feedback>
                                </b-col>
                            <b-col cols="12" md="12" lg="12">
                                <label for="email_pesquisado">Motivo da Solicitação:</label>
                                <b-form-textarea
                                  id="motivo_solicitacao"
                                  v-model="motivo_solicitacao"
                                  placeholder="Digite o motivo da solicitação"
                                  rows="3"
                                  max-rows="6"
                                  :state="motivo_solicitacaoState"
                                ></b-form-textarea>
                                <b-form-invalid-feedback
                                      :state="motivo_solicitacaoState"
                                    >
                                      Preencha no minimo 10 caracteres.
                                    </b-form-invalid-feedback>
                                </b-col>                                    
                        </b-row>
                        <br><br><br><br>
                        <b-row>
                      <b-col cols="10" >
                      </b-col>
                      <b-col cols="12" md="2">
                        <b-button block variant="primary" type="button" @click="valida_dados">Prosseguir</b-button>
                      </b-col>
                    </b-row>
                      </b-card-text>
                    </b-card>
                  </div>
                  <br>
                  <div>
                    
                    

                  </div>
                      </div>
                    </b-tab>
                    <b-tab title="02" class="tab2-protesto">
                      <b-card
                border-variant="primary-ieptb"
                header-text-variant="primary-ieptb"
                header="Confira so dados"
                color="red"
                class="card-ieptb"
              >
              <template v-slot:header>
                Confira os dados
              </template>
              <b-card-text>
                <b-row>
                  <b-col cols="12" md="6" lg="6">
                    <label  class="conferencia_dados_label"><b>Nome completo do pesquisado: </b> {{ form.nome_solicitante }}</label>
                  </b-col>
                  <b-col cols="12" md="6" lg="6">
                    <label  class="conferencia_dados_label float-right"><b>Documento do pesquisado: </b> {{ documento_solicitante }}</label>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="6" lg="6">
                    <label  class="conferencia_dados_label"><b>RG pesquisado: </b> {{ form.rg_solicitante }}</label>
                  </b-col>
                  <b-col cols="12" md="6" lg="6">
                    <label class="conferencia_dados_label float-right"><b>E-mail: </b> {{ form.dadosPesquisado.email }}</label>
                  </b-col>
                </b-row>
                
                <b-row>                    
                  <b-col cols="12" md="6" lg="6">
                    <label class="conferencia_dados_label"><b>Endereço:</b> {{ form.dadosPesquisado.endereco }}</label>
                  </b-col>
                  <b-col cols="12" md="6" lg="6">
                    <label class="conferencia_dados_label float-right"><b> UF: </b> {{ form.dadosPesquisado.uf }}</label>
                  </b-col>
                </b-row>

                <b-row> 
                  <b-col cols="12" md="6" lg="6">
                    <label class="conferencia_dados_label"><b>Cidade: </b> {{ form.dadosPesquisado.cidade }}</label>
                  </b-col>
                  <b-col cols="12" md="6" lg="6">
                    <label class="conferencia_dados_label float-right"><b>CEP: </b> {{ form.dadosPesquisado.cep }}</label>
                  </b-col>
                </b-row>
                <b-row> 
                    <b-col cols="12" md="6">
                      <label class="conferencia_dados_label"><b>Bairro: </b> {{ form.dadosPesquisado.bairro }}</label>
                    </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" md="12" lg="12"><h5 class="mt-5">Dados Cartorio</h5><hr></b-col>                      
                </b-row>
                <b-row>
                  <b-col cols="12" md="6" lg="6">
                    <label  class="conferencia_dados_label"><b>Estado: </b>{{ ufSelecionada }}</label>
                  </b-col>
                  <b-col cols="12" md="6" lg="6">
                    <label  class="conferencia_dados_label float-right"><b>Município: </b> {{ municipioSelecionado }}</label>
                  </b-col>
                </b-row>
                <b-row v-for="cartorio in form.cartorios_selecionados">
                  <b-col cols="12" md="12">
                    <label  class="conferencia_dados_label"><b>Cartório: </b>  {{ cartorios.find( e => e.value == cartorio).text }}</label>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="12">
                    <label class="conferencia_dados_label"><b>Motivo da Solicitação: </b> {{ motivo_solicitacao }}</label>
                  </b-col>
                </b-row>
                <br><br><br><br>
                <b-row>
                  <b-col cols="2" md="2" lg="2">
                    <b-button block variant="danger" type="button" @click="tabIndex--" >Corrigir Dados</b-button>
                  </b-col>
                  <b-col cols="8" md="8" lg="8" >
                  </b-col>
                  <b-col cols="2" md="2" lg="2" >
                    <b-button block variant="primary" type="button" @click="gerar">Pedir certidão</b-button>
                  </b-col>
                </b-row>
                    


              </b-card-text>
            </b-card>
                    </b-tab>
                  </b-tabs>

                  
                </b-form>

              </b-container>
          </b-col>
      </b-row>
    </div>
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
    import Header from '../../components/Header'
    import API from '../../services/api'
    import Menu from '../../template/Menu'
    import Serv from '../../services'
    import axios from "axios"
    import footersite from "@/components/footersite";
    import footersitemobile from "@/components/footersite/index_mobile";

    //import Modal from '../../components/modal/Confmodal'


    export default {
        components: {
            Header,
            Menu,
            footersite,
            footersitemobile
          //Modal,
        },
        data() {
            return {
              logged:false,
              loggedLoading:true,
              tabIndex:1,
              breadCrumb:[
                {text: 'Painel',href: "/painel" },
                {text: 'Certidão',disabled: true},
                {text: 'Novo Pedido',active: true}
              ],
              dismissSecs: 5,
              dismissCountDown: 0,
              dismissCountDownDOC: 0,
              dismissCountDownSuc: 0,
              arquivosCertidao: [],
              loading: true,
              show: true,
              sg_uf:null,
              procuracao:{},
              pesquisado_cep:null,
              motivo_solicitacao:'',
              documento_solicitante:'',
              exibeRG:null,
              form:{
                nome_solicitante:'',
                documento_solicitante: '',
                rg_solicitante:'',
                dadosPesquisado:{
                  cep:'',
                  endereco:'',
                  uf:'',
                  cidade:'',
                  bairro:'',
                  email:''
                },
                ufselecionada: '',
                comarca_selecionada:'',
                cartorio_selecionado:'',
                cartorios_selecionados: []
              },
              alertMessage: '',
              servicosEletronicos: [], // Must be an array reference!
              options: [],
              erroPushMsg: '',
              erroPushRoute: {name:'painel'},
              modalShow: false,
              newWindow: '',
              cd_procuracao : '',
              cdibgeselecionado: '',
              estadoSelecionado: '',
              cartorioSelecionado:'',
              estados: [],
              municipios: [],
              cartorios: [],
              validation_nome_solicitante:null,
              validation_documento_solicitante:null,
              validation_rg_solicitante:null,
              validation_uf_selecionada:null,
              validation_comarca_selecionada:null,
              validation_cartorios_selecionados:null,
              motivo_solicitacaoState:null,
              validations: {
                pesquisado_cep: null,
                pesquisado_endereco: null,
                pesquisado_uf: null,
                pesquisado_cidade: null,
                pesquisado_bairro: null,
              }
            }
        },
        filters: {
          documento: function (value) {
            if (value == null) {
                return '';
            } else {
                let v = value;
                //Remove tudo o que não é dígito
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    //de novo (para o segundo bloco de números)
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um hífen entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    //Coloca ponto entre o segundo e o terceiro dígitos
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                    //Coloca ponto entre o quinto e o sexto dígitos
                    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                    //Coloca uma barra entre o oitavo e o nono dígitos
                    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                    //Coloca um hífen depois do bloco de quatro dígitos
                    v = v.replace(/(\d{4})(\d)/, "$1-$2");
                }
                return v;
            }
          },
          dataHora: function (value) {
            if (value !== "" && value !== undefined && value !== null){
            let date = new Date(value);
            return date.toLocaleDateString("pt-BR", {
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric'
                });
            }
            return "";
          },
          Celular: function (value){
            var d = value
            d = d.replace(/\D/g, "")
            d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
            d = d.replace(/(\d{5})(\d)/, "$1-$2")
            return d
          },
          Telefone: function (value){
            var d = value
            d = d.replace(/\D/g, "")
            d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
            d = d.replace(/(\d{4})(\d)/, "$1-$2")
            return d
          },
          Moeda: function (v){
            /*var p = v.indexOf(".");
            v = v.slice(0, (p+3))
            v = v.replace(/\D/g,'');
            v = (v/100).toFixed(2) + '';
            */
            v = v.toString().replace(".", ",");
            v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
            v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
            return 'R$ ' + v;
          }
        },
        computed:{
          ufSelecionada(){
            if(this.estados.length > 0){
              if(this.estadoSelecionado != undefined && this.estadoSelecionado != ''){
                return this.estados.find( (e) => e.value == this.estadoSelecionado).text
              }
            }
            return false;
          },
          municipioSelecionado(){
            if(this.municipios.length > 0){
              if(this.form.comarca_selecionada != undefined && this.form.comarca_selecionada != ''){
                return this.municipios.find( (e) => e.value == this.form.comarca_selecionada).text
              }
            }
            return false;
          },
        },
        watch: {
          pesquisado_cep: function(val)
          {
            if(val.length == 9)
            {
              this.form.dadosPesquisado.cep = val;
              this.BuscarCep(val)
              this.validations.pesquisado_cep = true
            }
            else this.validations.pesquisado_cep = false
          },
          documento_solicitante: function(val)
          {
            this.validarDocumento(val)
            if(this.sg_uf == 'MS' && this.documento_solicitante.length == 14)
            {
              this.exibeRG = true
              // this.document.getElementById('sg_rg').focus();
              setTimeout(()=> {this.$refs.sg_rg.focus()},1)
            }
            else this.exibeRG = false
          },
          sg_uf: function(val){
            if(val == "MS" && this.documento_solicitante.length == 14)
            {
              this.exibeRG = true
              // this.document.getElementById('sg_rg').focus();
              setTimeout(()=> {this.$refs.sg_rg.focus()},1)
            }
            else this.exibeRG = false
          },
          exibeRG: function(val){
            this.rg_solicitante =  !val ? null : this.rg_solicitante
          }
        },
        created: function() {
          this.loading = true
          //localStorage.setItem('cd_procuracao', 121)
          const token = localStorage.getItem('jwtToken')
          let self = this
          let dadosUsuario =  API.get(`usuario/logado?token=${token}`).then( (res) =>  {
            setTimeout(() => {
              API.get(`usuario/dadosbancarios?token=${token}`).then((dadosBancarios) => {
                //  if (!res.data[0].nm_nr_cep || !res.data[0].nm_nr_telefone) { -- Nessa condição, nm_nr_cep E nm_nr_telefone são obrigatorios
                // if (!res.data[0].nm_nr_cep && !res.data[0].nm_nr_telefone) { // Nessa condição, somente um dos valores é obrigatorio
                //   this.blockForm();
                //   this.loading = false;
                //   this.erroPushMsg = 'Cadastro do usuário incompleto. Para realizar esse procedimento é preciso fornecer mais informações.'
                //   this.erroPushRoute = {name: 'cadastroUser'}
                //   // this.erroPushRoute = {name: 'cadastroUser', params: {dadosLiq: 'liquidacao', dadosBancarios:0}}
                //   this.$refs['erroPush'].show();
                // }
                // else{
                // if (dadosBancarios.data === "") {
                //   this.blockForm();
                //   this.loading = false;
                //   this.erroPushMsg = 'Cadastro do usuário incompleto. Para realizar esse procedimento é preciso fornecer mais informações.'
                //   this.erroPushRoute = {name: 'cadastroUser'}
                //   this.$refs['erroPush'].show();
                // }
                // else{
                  self.form.nome_solicitante = res.data[0].nm_usuario
                  self.documento_solicitante = res.data[0].nm_nr_cpfcnpj
                  self.form.documento_solicitante = res.data[0].nm_nr_cpfcnpj
                  self.form.rg_solicitante = res.data[0].nm_rg
                  self.form.dadosPesquisado.email = res.data[0].nm_email
                  self.pesquisado_cep = res.data[0].nm_nr_cep != null ? res.data[0].nm_nr_cep.substring(0, 5) + '-' + res.data[0].nm_nr_cep.substring(6, 9) : ''   
                  this.buscaEstados();
                  this.loading = false;
                // }
              });
            },10);
          });
          this.logged = true
          this.loggedLoading = false
        },
        methods: 
        {
            limparDados(){

             

              this.form.nome_solicitante = ''
              this.form.documento_solicitante =  ''
              this.form.rg_solicitante = ''
              this.form.dadosPesquisado.cep = ''
              this.form.dadosPesquisado.endereco = ''
              this.form.dadosPesquisado.uf = ''
              this.form.dadosPesquisado.cidade = ''
              this.form.dadosPesquisado.bairro = ''
              this.form.dadosPesquisado.email = ''
              this.form.ufselecionada =  ''
              this.form.comarca_selecionada = ''
              this.form.cartorio_selecionado = ''
              this.form.cartorio_selecionado = ''
              this.form.ufselecionada = ''
              this.form.cartorios_selecionados =  []

              this.sg_uf = ''
              this.documento_solicitante = ''
              this.pesquisado_cep = ''
              this.motivo_solicitacao = ''
              this.cartorios = []





              // this.documento_solicitante = ''
              // this.pesquisado_cep('')
            },
            async buscaEstados() 
            {
              const res = await API.get(`/uf`)
              this.estados = res.data;
              this.loading = false
            },
            selecionaUf(iduf) 
            {
              this.buscarMunicipios(iduf)
              this.estadoSelecionado = iduf
              this.form.comarca_selecionada = ''
              this.form.cartorios_selecionados = []
              this.cartorios = []
            },
            async buscarMunicipios(iduf) 
            {
              this.loading = true
              const res = await API.get(`/municipios?iduf=` + iduf)
              this.municipios = res.data;
              this.loading = false
              this.form.comarca_selecionada = ''
              this.form.cartorios_selecionados = []
            },
            async buscarCartorios(cdibge) 
            {
              this.loading = true
              this.cartorios = []
              const res = await API.post(`/cartorios/numero`,{cdibge: cdibge})
              this.cartorios.push({value:'1000', text:'Todos'})
              res.data.forEach(element => {
                 this.cartorios.push({value: element.value, text: element.text})
              });
              this.form.cartorios_selecionados = []
              this.loading = false
            },
            selecionaCartorio(cartorio){
              
              if(cartorio[0] == 1000)
              {
                this.cartorios.forEach((element) => {
                  this.form.cartorios_selecionados.push(element.value)
                  if(this.form.cartorios_selecionados[0] == 1000)this.form.cartorios_selecionados = []
                });
              }
              else this.form.cartorios_selecionados = cartorio
            },
            documento: function (event) {
              // console.log(event)
              var value = event
              if (value == null) {
                  return '';
              } else {
                let v = value;
                //Remove tudo o que não é dígito
                v = v.replace(/[^a-zA-Z0-9]/g, "");
                if (v.length == 11) { //CPF
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    //de novo (para o segundo bloco de números)
                    v = v.replace(/(\d{3})(\d)/, "$1.$2");
                    //Coloca um hífen entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else if(v.length == 9) {
                  v = v.replace(/(\d{2})(\d{3})(\d{3})([\dA-Za-z])/, "$1.$2.$3-$4") 
                } else if ( v.length == 10){
                  v = v.replace(/(\d{3})(\d{3})(\d{3})([\dA-Za-z])/, "$1.$2.$3-$4")
                }else { //CNPJ
                    //Coloca ponto entre o segundo e o terceiro dígitos
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                    //Coloca ponto entre o quinto e o sexto dígitos
                    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                    //Coloca uma barra entre o oitavo e o nono dígitos
                    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                    //Coloca um hífen depois do bloco de quatro dígitos
                    v = v.replace(/(\d{4})(\d)/, "$1-$2");
                }
                return v;
            }
          },
          validarDocumento: function (value) {
              let documento = value.replace('.','').replace('.','').replace('-','').replace('/','')
              if(documento.length > 11){
                if(this.form.dadosPesquisado.uf == 'MS')this.exibeRG = false
                if(!Serv.validarCNPJ(documento))this.validation_documento_solicitante = false
                else this.validation_documento_solicitante = true
                
              }else{
                if(this.form.dadosPesquisado.uf == 'MS')this.exibeRG = true
                if(!Serv.validarCPF(documento))this.validation_documento_solicitante = false
                else this.validation_documento_solicitante = true

              }
          },
          valida_dados(){
            this.form.dadosPesquisado.uf = this.sg_uf

            let travaDadosPes = false;
            let motivo_solicitacao_sem_espaco = this.motivo_solicitacao.trim()

            if(this.form.nome_solicitante.length <= 1)this.validation_nome_solicitante = false
            else this.validation_nome_solicitante = true
            
            if(this.documento_solicitante.length <= 1 || !this.validation_documento_solicitante)this.validation_documento_solicitante = false
            else this.validation_documento_solicitante = true

            if((this.sg_uf == "MS" &&  this.documento_solicitante.length == '14' && this.rg_solicitante != undefined && this.rg_solicitante.length <= 1) || this.sg_uf != "MS")this.validation_rg_solicitante = true
            else this.validation_rg_solicitante = false

            if(this.form.ufselecionada.length <= 1)this.validation_uf_selecionada = false
            else this.validation_uf_selecionada = true

            if(this.form.comarca_selecionada.length <= 1)this.validation_comarca_selecionada = false
            else this.validation_comarca_selecionada = true

            if(this.form.cartorios_selecionados[0] == undefined)this.validation_cartorios_selecionados = false
            else this.validation_cartorios_selecionados = true

            
            if(motivo_solicitacao_sem_espaco == null || motivo_solicitacao_sem_espaco.length<10)
            {
              this.motivo_solicitacaoState = false;
              travaDadosPes = true;
            }
            else this.motivo_solicitacaoState = true;
            
            Object.keys(this.form.dadosPesquisado).forEach(element => { 
              //console.log(element)
              let elementoAtual = this.form.dadosPesquisado[element].trim()
              let validationErro =  'pesquisado_' + element
              if(elementoAtual.length<=0 && element != 'email')
              {
                this.validations[validationErro] = false
                travaDadosPes = true
              }
              else this.validations[validationErro] = true
            })

            if(    this.validation_nome_solicitante 
                && this.validation_documento_solicitante 
                && this.validation_uf_selecionada 
                && this.validation_comarca_selecionada
                && this.validation_cartorios_selecionados
                && !travaDadosPes
            )
            {
              let aCartorios = [];

              for(var cartorios in this.form.cartorios_selecionados)
              {
                let cartorio = {
                  titulos:[{
                    titulo:{
                      selected:true,
                      cpfCnpj:this.documento_solicitante
                    },
                  }],
                  cod_cartorio:this.form.cartorios_selecionados[cartorios],
                  cod_ibge:this.form.comarca_selecionada
                }
                
                aCartorios.push(cartorio);
              }
              this.tabIndex = 2;
            }
            else{
              this.alertMessage = "Erro no preenchimento do formulário."
              this.$refs['alertModal'].show();
            }
            // this.tabIndex = !travaDadosPes ? 2 : this.tabIndex;
          },
          async gerar(){

           let aCartorios = [];
           let motivo_solicitacao_sem_espaco = this.motivo_solicitacao.trim()
           
           for(var cartorios in this.form.cartorios_selecionados)
            {
              let cartorio = {
                titulos:[{
                  titulo:{
                    selected:true,
                    cpfCnpj:this.documento_solicitante
                  },
                }],
                cod_cartorio:this.form.cartorios_selecionados[cartorios],
                cod_ibge:this.form.comarca_selecionada
              }
              
              aCartorios.push(cartorio);
            }

            const token = localStorage.getItem("jwtToken");
             this.loading = true
             const res = await API.post(`certidao`,{
                token: token, 
                envio:'D', 
                cartorios:aCartorios, 
                nome:this.form.nome_solicitante,
                documento:this.documento_solicitante,
                rg_solicitante : this.form.rg_solicitante,
                nr_cep_pesquisado: this.form.dadosPesquisado.cep,
                nm_endereco_pesquisado : this.form.dadosPesquisado.endereco,
                nm_bairro_pesquisado : this.form.dadosPesquisado.bairro,
                nm_cidade_pesquisado : this.form.dadosPesquisado.cidade,
                nm_uf_pesquisado : this.sg_uf,
                nm_email_pesquisado : this.form.dadosPesquisado.email,
                cd_produto:'4',
                motivo_solicitacao: motivo_solicitacao_sem_espaco
              })
              this.loading = false
              if(res.data.inserido>0)
              {
                this.erroPushMsg = 'Solicitação efetuada com sucesso. Clique no menu "Pedido de certidão > Todos os Pedidos" para acompanhar a situação dos pedidos.'
                this.erroPushRoute = {name:'painel'}
                this.$refs['erroPush'].show();
                
              }
              else 
              {
                if(res.data.descricao != undefined && res.data.descricao != null)this.erroPushMsg = res.data.descricao
                else this.erroPushMsg = 'Falha ao processar a solicitação, antes de fazer uma nova solicitação verifique se o Pedido foi realizado no menu "Pedido de certidão > Todos os Pedidos". Erro: ' + res.data.erro
                this.erroPushRoute = {name:'painel'}
                this.$refs['erroPush'].show();
              }

          },
          confirmaErroPush(){
            this.$router.push(this.erroPushRoute);
            this.$refs['erroPush'].hide();
          },
          BuscarCep: function(cep){
            var cepl = cep.replace("-","");
            try{
                axios.get(`https://viacep.com.br/ws/${cepl}/json/`).then(resp => {
                  if (resp.data.erro == true) {
                    this.alertMessage = "Cep não encontrado."
                    this.$refs['alertModal'].show();
                  } else {
                    this.form.dadosPesquisado.cep = cepl
                    this.form.dadosPesquisado.endereco = resp.data.logradouro + ' ' + resp.data.complemento.substr(0,60)
                    this.form.dadosPesquisado.bairro  = resp.data.bairro.substr(0,45)
                    this.form.dadosPesquisado.cidade = resp.data.localidade.substr(0,45)
                    this.form.dadosPesquisado.uf = resp.data.uf
                    this.sg_uf = resp.data.uf
                  }
                }).catch(() => {
                  this.alertMessage = "Cep não encontrado."
                  this.$refs['alertModal'].show();
                  console.error('error')
                })
            }catch(error){
                console.error('error')
            }
        },
          cep: function (event){
            var d = event
            if(d != null)
            {
              d = d.replace(/\D/g, "")
              d = d.replace(/^(\d{5})(\d)/, "$1-$2")             
              return d;
            }
          },
          blockForm(){
            const form = document.getElementById('frmProcuracao');
            if (form) {
              const elementsToDisable = form.querySelectorAll('input, select, textarea, button, a');
              elementsToDisable.forEach(element => {element.disabled = true;});
            }
          }
        },
    }
</script>

<style scoped>
#painel .tab2-protesto h4{font: normal normal bold 30px/30px 'Kanit', sans-serif;}
#painel .tab2-protesto label{font: normal normal normal 15px/20px 'Kanit', sans-serif;}
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
    
#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  overflow-x: hidden;
    border-top: 1px solid #f1f1f1;
}
    .lista-certidoes {
        color: #000;
    }
    .lista-certidoes b {
        font-size: 0.85rem;
        color: var(--main-azul);
    }

    a {
        color: #555;
    }
    .shadow {
        box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
    }
    #loading-solicitante {
        vertical-align: 0;
        margin-left: -21px;
    }
    .load{
        top: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .spin {
        background: #fff;
        height: 80px;
        width: 80px;
        border-radius: 50vh;
        border-color: #209CEE;
        border-top: 5px solid  #209CEE;
        animation: loading 3s linear infinite;
    }
    .loading{
        position: absolute;
        color: #000;
    } @keyframes loading{
        100%{
            transform: rotate(360deg)
        }
    }
    .bold{
    font-weight: bold;
    }
    .mensagemErro{
      color: red;
    }
    #cabecalho{
      z-index: 0 !important;
    }
    
#painel > .row{justify-content: space-between;}

#painel{scrollbar-width:none;}
#painel::-webkit-scrollbar{display:none;}
.espaco-menu{width: calc(296px + 5px + 5px);flex: unset;margin-left: calc(3.8vw - 5px);}
#painel h1 {text-align: left;font: normal normal bold 30px/41px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 33px;}

#painelcontainerfluid{padding:0;padding-bottom: 52px;padding-right: 3.8vw;margin-top: 37px;}
.solicitar-certidao-buttons {height:48px;}
.solicitar-certidao-buttons button{height:inherit;width:130px;margin:0;}
.solicitar-certidao-buttons button.btn-limpardados{}
.solicitar-certidao-buttons button.btn-pedircertidao{}
@media (max-width:1600px) and (min-width:1400px){
  .espaco-menu{margin-left: calc(20px - 5px) !important;}  
  #painelcontainerfluid{padding-right: 20px !important;}
}
@media (max-width:1399px) and (min-width:1200px){
  .espaco-menu{margin-left: calc(10px - 5px) !important;}
  #painelcontainerfluid{padding-right: 10px !important;}
}

@media (max-width:1199px){
  #painel {padding:0 17px;}
  #painel > .row{
    width: 100%;
    max-width: none;
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
  }
  .col-lg-9{max-width: none;flex: 1 1 100%;}
  #painelcontainerfluid{padding:0px !important;}
}
.breadcrumb-row{z-index: 999;position: relative;}
.breadcrumb{margin-left: 0px;background: unset;}
.breadcrumb a, .breadcrumb span, .breadcrumb-item + .breadcrumb-item::before{font: normal normal 200 16px/20px 'Kanit', sans-serif;}
.breadcrumb-item + .breadcrumb-item::before{float:unset;}
.breadcrumb a{color:var(--primary-color);}
.breadcrumb-item + .breadcrumb-item::before{color:var(--primary-color);}
.breadcrumb span{color:var(--secondary-color);}
.breadcrumb a.disabled{text-decoration:none;cursor:default;}
.btn-voltar {display: flex;align-items: center;margin-left: auto;letter-spacing: 0px;text-decoration: none;justify-content: flex-end !important;margin-bottom: 20px;}
.btn-voltar img{width: 20px;height: 20px;margin-left: 6px;}

figure.flag.flag-notificacao img {
  width: 34px;
  margin-top: -5px;
  margin-right: 10px;
}

.alert.alert-warning,
.alert.alert-danger{
  max-height: 49px;
  padding: 15px 17px;
  border-radius: 5px;
  font: normal normal bold 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  text-align:start !important;
}
.alert.alert-warning{
  background: #F8F5CB 0% 0% no-repeat padding-box;
  color: #706927;
}
.alert.alert-danger{
  background: #F8CBCB 0% 0% no-repeat padding-box;
  color: #702727;
}
.alert.alert-danger a{
  color: #702727 !important;
  font: normal normal bold 15px/20px 'Kanit', sans-serif !important;
  text-decoration: none;
}
</style>
